import { darken, mix, rgba } from 'polished';

import { interpolateRecord } from '@/utils/theme/utils';

import {
  base,
  type BaseFgShades,
  type BaseGridShades,
  type BgShades,
  type PaletteShape
} from './palette';

export const fgShades: BaseFgShades = {
  '100': 0,
  '200': 0.03,
  '300': 0.05,
  '400': 0.07,
  '500': 0.09,
  '600': 0.11,
  '700': 0.14,
  '800': 0.22,
  '900': 0.44,
  '1000': 0.48,
  '1100': 0.57,
  '1200': 0.91
};

export const gridShades: BaseGridShades = {
  '200': 0.077,
  '300': 0.103,
  '400': 0.129,
  '500': 0.172,
  '600': 0.249,
  '700': 0.386,
  '1200': 0.923
};

const fg = interpolateRecord(fgShades, 'fg', v =>
  mix(v, base.violetTopaz, '#EBEBEB')
);

const fgA = interpolateRecord(fgShades, 'fgA', v => rgba(base.violetTopaz, v));

const grid = interpolateRecord(gridShades, 'grid', v =>
  mix(v, base.violetTopaz, '#EBEBEB')
);

export const bgShades: BgShades = {
  '300': 0.025,
  '400': 0.125,
  '500': 0
};

const bg = interpolateRecord(bgShades, 'bg', v => darken(v, '#EBEBEB'));

export const palette: PaletteShape = {
  ...base,
  ...fg,
  ...fgA,
  ...grid,
  ...bg,
  fgLoud: base.obsidian
};
